import React from 'react';
import { PRIMARY_COLOR, BACKGROUND_DARK } from '../constants';
import { injectIntl } from 'react-intl';



class Counter extends React.Component{

  render(){
    return (
      <svg
        width="100%"
        height="118px"
        viewBox="0 0 120 118"
        version="1.1"
        id="SVGRoot">
        <g
          id="layer1">
          <g
            id="g1511"
            transform="matrix(0.96153846,0,0,0.96153846,11.923077,2.2692308)">
            <rect
              ry="50"
              y="9"
              x="0"
              height="100"
              width="100"
              id="rect931"
              style={{fill: PRIMARY_COLOR, stroke: BACKGROUND_DARK, strokeWidth: 4, strokeMiterlimit: 4, strokeDasharray: 'none', strokeOpacity: 1}} />
            <text
              id="text1496"
              y="86.632523"
              x="49.852928"
              style={{fontStyle: 'normal', fontWeight: 'normal', fontSize: '40px', lineHeight: 1.25, fontFamily: 'sans-serif', fill: 'white', fillOpacity: 1, stroke: 'none'}}
              ><tspan
                style={{fontStyle: 'normal', fontVariant: 'normal', fontWeight: 'normal', fontStretch: 'normal', fontSize: '10.6667px', fontFamily: 'sans-serif', fontVariantLigatures: 'normal', fontVariantCaps: 'normal', fontVariantNumeric: 'normal', fontVariantEastAsian: 'normal', textAlign: 'center', textAnchor: 'middle'}}
                id="tspan1498"
                y="86.632523"
                x="49.852928">
                  {
                    this.props.value === 1 ?
                      this.props.intl.formatMessage({ id: this.props.singular }) : 
                      this.props.intl.formatMessage({ id: this.props.plural })
                  }
              </tspan></text>
            <text
              id="text1504"
              y="64.147736"
              x="49.094524"
              style={{fontStyle: 'normal', fill: 'white', fontWeight: 'normal', fontSize: '40px', lineHeight: 1.25, fontFamily: 'sans-serif', fillOpacity: 1, stroke: 'none'}}
              ><tspan
                style={{fontStyle: 'normal', fontVariant: 'normal', fontWeight: 'normal', fontStretch: 'normal', fontSize: '42.6667px', fontFamily: 'sans-serif', fontVariantLigatures: 'normal', fontVariantCaps: 'normal', fontVariantNumeric: 'normal', fontVariantEastAsian: 'normal', textAlign: 'center', textAnchor: 'middle'}}
                y="64.147736"
                x="49.094524"
                id="tspan1502">{this.props.value}</tspan></text>
          </g>
        </g>
      </svg>

    );
  }
}


export default injectIntl(Counter);


// WEBPACK FOOTER //
// ./src/components/Counter.js